<template>
    <button
        class="bax-btn"
        :class="[
            (color == 'primary') ? 'bax-btn-blue' : '',
            (color == 'link') ? 'bax-btn-bordered bax-btn-bordered-blue' : '',
            (color == 'default') ? 'bax-btn-bordered bax-btn-bordered-dark-gray-1' : '',
            (color == 'green') ? 'bax-btn bax-btn-green-3' : '',
            (isRound === true) ? 'bax-btn-round' : '',
        ]"
        @click="$emit('click')"
    >
        <slot />
    </button>
</template>

<script>
export default {
    name: 'VueButton',
    props: {
        color: {},
        isRound: {},
    },
    created() {
        if (this.$attrs.round === '') {
            this.isRound = true;
        }
    },
};
</script>

<style scoped>
.bax-btn-default {

}
.bax-btn-round {
    border-radius: 50%;
    text-align: center;
    padding: 0.625rem 1rem;
}
</style>
